<template>
  <div class="change-password-form"
       :class="formMobileStyles">
    <div class="input-fields">
      <div class="input-title">
        {{ $t("passwordChange.currentPassword") }}
      </div>

      <div class="password-input"
           :class="currentPasswordStyle">
        <input v-validate="'required'"
               v-model="currentPassword"
               name="current_password"
               :type="showCurrentPassword ? 'text' : 'password'"
               class="input"
               :class="currentPasswordStyle"
               :placeholder="$t('passwordChange.currentPassword')"
               data-vv-as="current password">

        <div class="password-icon"
             :class="showCurrentPassword ? 'password-icon_on' : 'password-icon_off'"
             :title="showCurrentPassword ? 'Hide password' : 'Show password'"
             @click="showCurrentPassword = !showCurrentPassword">
          <component width="24"
                     height="24"
                     :is="showCurrentPassword ? 'icon-eye-on' : 'icon-eye-off'" />
        </div>
      </div>

      <div v-show="errors.has('current_password')"
           class="is-danger"
           :class="currentPasswordStyle">
        {{ errors.first('current_password') }}
      </div>

      <div class="input-title new">
        {{ $t("passwordChange.newPassword") }}
      </div>

      <div class="password-input"
           :class="newPasswordStyles">
        <input v-validate="'required'"
               v-model="password"
               name="password"
               :type="showNewPassword ? 'text' : 'password'"
               class="input"
               :class="newPasswordStyles"
               :placeholder="$t('passwordChange.newPassword')"
               ref="password">

        <div class="password-icon"
             :class="showNewPassword ? 'password-icon_on' : 'password-icon_off'"
             :title="showNewPassword ? 'Hide password' : 'Show password'"
             @click="showNewPassword = !showNewPassword">
          <component width="24"
                     height="24"
                     :is="showNewPassword ? 'icon-eye-on' : 'icon-eye-off'" />
        </div>
      </div>

      <div class="password-input"
           :class="newPasswordStyles">
        <input v-validate="'required|confirmed:password'"
               v-model="confirmPassword"
               name="password_confirmation"
               :type="showConfirmPassword ? 'text' : 'password'"
               class="input"
               :class="newPasswordStyles"
               :placeholder="$t('passwordChange.confirmPassword')"
               data-vv-as="new password">

        <div class="password-icon"
             :class="showConfirmPassword ? 'password-icon_on' : 'password-icon_off'"
             :title="showConfirmPassword ? 'Hide password' : 'Show password'"
             @click="showConfirmPassword = !showConfirmPassword">
          <component width="24"
                     height="24"
                     :is="showConfirmPassword ? 'icon-eye-on' : 'icon-eye-off'" />
        </div>
      </div>

      <div v-show="errors.has('password_confirmation') || errors.has('password')"
           class="is-danger"
           :class="newPasswordStyles">
        {{ errors.first('password_confirmation') }}
      </div>
    </div>
    <div class="confirmation">
      <base-button class="submit-button"
                   color="secondary"
                   type="submit"
                   @click="onChangeConfirm">
            {{ $t("passwordChange.change") }}
      </base-button>
    </div>
  </div>
</template>

<script>
  import passwordApi from '@/api/password.js'

  export default {
    data() {
      return {
        currentPassword: '',
        password: '',
        confirmPassword: '',
        showCurrentPassword: false,
        showNewPassword: false,
        showConfirmPassword: false
      }
    },

    methods: {
      onChangeConfirm() {
        this.$validator.validateAll()
          .then(valid => {
            if (!valid) {
              return
            }

            passwordApi.changePassword(
              this.currentPassword,
              this.password,
              this.currentUser.id
            )
              .then(() => {
                this.$emit('close')
                this.$notify({
                  type: 'success',
                  text: 'Password successfully changed.'
                })
              })
              .catch(error => {
                this.$notify({
                  type: 'error',
                  text: error
                })
              })
          })
      }
    },

    computed: {
      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      currentPasswordStyle() {
        return {
          'wrong-password': this.errors.has('current_password'),
          'borders': !this.errors.has('current_password')
        }
      },

      newPasswordStyles() {
        return {
          'wrong-password': this.errors.has('password') || this.errors.has('password_confirmation'),
          'borders': !(this.errors.has('password') || this.errors.has('password_confirmation'))
        }
      },

      formMobileStyles() {
        return {
          'change-password-form-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .change-password-form {
    width: 100%;
    min-height: 400px;

    .input-fields {
      width: 100%;

      .input-title {
        color: map.get($colors, primary);
        font-weight: bold;
        letter-spacing: 1px;
        margin-bottom: 24px;
      }

      .password-input {
        display: flex;
        align-items: center;

        .password-icon {
          display: flex;
          align-items: center;
          height: 100%;
          padding: 0 10px;
          cursor: pointer;
          user-select: none;

          &_on {
            color: map.get($colors, primary);
          }

          &_off {
            color: #999;
          }
        }
      }

      .new {
        margin-top: 32px;
      }

      .input {
        width: 100%;
        height: 48px;

        outline: none;
        border: none;
        font-size: 20px;

        &::placeholder {
          color: #3e3a3b;
          opacity: .5;
        }
      }
    }

    .confirmation {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 32px;

      .submit-button {
        width: 400px;
        margin: 0 auto 18px auto;
        padding: 23px;
        font-size: 28px;
        font-weight: bold;
      }
    }
  }

  .wrong-password {
    background: color.adjust(#f25b5b, $lightness: 25%);
  }

  .borders {
    border-top: 1px solid #f2f2f2;
    border-bottom: 1px solid #f2f2f2;
  }

  .is-danger {
    width: 100%;
    margin: 0;
    padding-bottom: 10px;
    font-size: 12px;
  }

  .change-password-form-mobile {
    .confirmation {
      .submit-button {
        width: 100%;
      }
    }
  }
</style>

